import React from 'react';
import PropTypes from 'prop-types';
import ConnectedPreview from './ConnectedPreview';

const PreviewRouting = ({ match }) => <ConnectedPreview />;

PreviewRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default PreviewRouting;
